export default {
  create: {
    success: 'Client créer avec succès',
    error: 'Impossible de créer le client'
  },
  update: {
    success: 'Modification du client effectué avec succès',
    error: 'Impossible de mettre à jour le client'
  },
  delete: {
    success: 'Client supprimé avec succès',
    error: 'Impossible de supprimer le client'
  }
}
